import "../Brand/brand.css";

import {
  faCheck,
  faChevronRight,
  faHeart,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  searsh_brand,
  show_brand,
  product_reviews,
  sort_products,
  filter_data,
  sort_data,
  filter_brducts,
  product_details,
  favorites,
  addFavorite,
  remove_favorites,
  show_Influencer,
  show_store
} from "../Redux/API";
import { searsh_product } from "../Redux/HomeSlice";
import icon9 from "../Icons/Icon-09.png";
import Loader from "../Loader";
import { category_data } from "../Redux/HomeSlice";
import Register from "../Register/Register";
import { showRegister } from "../Redux/HomeSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Searsh from "../Searsh/Searsh";

import "react-perfect-scrollbar/dist/css/styles.css"; // استيراد التنسيقات الافتراضية

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
function SubSupCategory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const gotoCategory = (category) => {
    localStorage.setItem("categoryData", JSON.stringify(category));
    dispatch(category_data(category));
    navigate("/SubSupCategory");
    window.scrollTo(0, 0);
  };

  // **حالة البحث**
  const [searshBroduct, setSearshBroduct] = useState("");
  const handleInputChangeReturns = (e) => {
    setSearshBroduct(e.target.value);
  };

  const [activeSource, setActiveSource] = useState(null); 

  useEffect(() => {
    if (searshBroduct) {
      dispatch(searsh_brand(searshBroduct));
      dispatch({ type: "RESET_SHOW_BRAND" });
      dispatch({ type: "RESET_FILTER_PRODUCTS" });
      dispatch({ type: "RESET_SORT_PRODUCTS" });
      setActiveSource("search");
    } else {
      dispatch(show_brand());
      dispatch({ type: "RESET_FILTER_PRODUCTS" });
      dispatch({ type: "RESET_SORT_PRODUCTS" });
      dispatch({ type: "RESET_SEARCH_BRANDS" });
      setActiveSource("brands");
    }
  }, [searshBroduct, dispatch]);

  const gotoProductDetails = (product) => {
    localStorage.setItem("Product_id", product.id);
    dispatch(product_details(product.id));
    dispatch(product_reviews(product.id));
    window.scrollTo(0, 0);
    navigate("/Product");
    dispatch(searsh_product(false));


    const id = product?.type?.id;
    if (!id || !product?.vendor_type) return;

    switch (product.vendor_type) {
      case "brand":
          localStorage.setItem('brandId', id);
          dispatch(show_brand({ id }));
          break;
      case "influencer":
          localStorage.setItem('InfluencerId', id);
          dispatch(show_Influencer({ id }));
          break;
      case "store":
          localStorage.setItem('storeId', id);
          dispatch(show_store({ id }));
          break;
      default:
          console.error("Unknown vendor type:", product.vendor_type);
    }
  };

  useEffect(() => {
    const savedCategory = localStorage.getItem("categoryData");
    if (savedCategory) {
      dispatch(category_data(JSON.parse(savedCategory)));
    }
  }, [dispatch]);

  const loadingSort_productS = useSelector(
    (state) => state.Data.loadingSort_productS
  );
  const loadingSearsh_brand = useSelector(
    (state) => state.Data.loadingSearsh_brand
  );

  const loadingShow_brand = useSelector(
    (state) => state.Data.loadingShow_brand
  );

  const categoryD = useSelector((state) => state?.products?.categoryD);
  console.log(categoryD)

  const searsh_brands = useSelector((state) => state.Data.searsh_brand);
  const show_brands = categoryD;
  const filter_brduct = useSelector((state) => state.Data.filter_brducts);
  const sort_product = useSelector((state) => state.Data.sort_products);

  const filters_data = useSelector((state) => state.Data.filter_data);
  const sorts_data = useSelector((state) => state.Data.sort_data);
  const loadingFilter_brduct = useSelector(
    (state) => state.Data.loadingFilter_brducts
  );


  const [allProducts, setAllProducts] = useState([]);

  useEffect(() => {
    let updatedProducts = [];

    if (activeSource === "brands" && show_brands?.products) {
      updatedProducts = [...show_brands?.products];
    }

    if (activeSource === "filter" && filter_brduct?.data?.data?.products) {
      updatedProducts = [...filter_brduct?.data?.data?.products];
    }

    if (activeSource === "search" && searsh_brands?.data?.data) {
      updatedProducts = [...searsh_brands?.data?.data];
    }

    if (activeSource === "sort" && sort_product?.data?.data?.products) {
      updatedProducts = [...sort_product?.data?.data?.products];
    }

    setAllProducts(updatedProducts);
  }, [activeSource, show_brands, filter_brduct, searsh_brands, sort_product]);

  const [icon, setIcon] = useState(false);
  const [text, setText] = useState(null);
  function handelClick() {
    setIcon(!icon);
  }

  function valueTeaxt(e) {
    setText(e);
  }

  useEffect(() => {
    dispatch(filter_data());
    dispatch(sort_data());
  }, [dispatch]);

  const category = localStorage.getItem("categoryData") 
  ? JSON.parse(localStorage.getItem("categoryData")) 
  : null;

  useEffect(() => {
    if (text) {
      dispatch(sort_products({
        sort: text,
        influencer_id: null,
        brand_id: null, 
        store_id: null, 
        category_id: category.id
      }));
      dispatch({ type: "RESET_SHOW_BRAND" });
      dispatch({ type: "RESET_FILTER_PRODUCTS" });
      dispatch({ type: "RESET_SEARCH_BRANDS" });
      setActiveSource("sort");
    }
  }, [dispatch, text]);

  const favorite = useSelector((state) => state?.Data?.favorites?.data?.data);
  const loadingRemove_favorites = useSelector((state) => state.Data.loadingRemove_favorites);
  const loadingAddFavorite = useSelector((state) => state.Data.loadingAddFavorite);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token =
    valueLocalStorage?.data?.token ||
    valueLocalStorage?.data?.data?.user?.token ||
    null;

  const showR = useSelector((state) => state?.products?.showR);

  useEffect(() => {
    if (!loadingAddFavorite && !loadingRemove_favorites) {
      dispatch(favorites()); 
    }
  }, [dispatch, loadingAddFavorite, loadingRemove_favorites]);

  const handelAdd_wishlist = (id, event) => {
    if (token) {
      const isInWishlist = favorite?.some((item) => item.product_id === id);
      if (isInWishlist) {
        dispatch(remove_favorites(id));
      } else {
        dispatch(addFavorite({ id }));
      }
    } else {
      const { pageY } = event;
      const offsetY = -100;
      setPopupPosition({ x: 50, y: pageY + offsetY }); 
      dispatch(showRegister(true));
    }
  };

  const Sign_Up = (event) => {
    if (!token) {
      const { pageY } = event;
      const offsetY = -1200;
      setPopupPosition({ x: 50, y: pageY + offsetY });
      dispatch(showRegister(true));
    }
  };
  useEffect(() => {
    const categoryData = localStorage.getItem("categoryData");
  
    if (categoryData) {
      const category = JSON.parse(categoryData);
      if (category?.id) { 
        dispatch(
          filter_data({
            influencer_id: null,
            brand_id: null,
            store_id: null,
            category_id: category.id,
          })
        );
        dispatch(
          sort_data({
            influencer_id: null,
            brand_id: null,
            store_id: null,
            category_id: category.id,
          })
        );
      }
    }
  }, [dispatch]);
  

  const [openIndex, setOpenIndex] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({
    brands: [],
    categories: [],
    prices: [],
    discounts: [],
    colors: [],
    sizes: [],
    category_id: category.id,
    influencer_id: null,
    brand_id: null, 
    store_id: null, 
  });
  const handleFilterDataClick = () => {
    dispatch(filter_brducts(selectedFilters));
    dispatch({ type: "RESET_SHOW_BRAND" });
    dispatch({ type: "RESET_SORT_PRODUCTS" });
    dispatch({ type: "RESET_SEARCH_BRANDS" });
    setActiveSource("filter");
    if (window.innerWidth <= 576) {
      toggleFilterVisibility();
    }
  };

  const items = [
    {
      title: t("categories"),
      key: "categories",
      subItems: filters_data?.data?.data?.categories,
    },
    {
      title: t("prices"),
      key: "prices",
      subItems: filters_data?.data?.data?.prices,
    },
    {
      title: t("discounts"),
      key: "discounts",
      subItems: filters_data?.data?.data?.discounts,
    },
    {
      title: t("sizes"),
      key: "sizes",
      subItems: filters_data?.data?.data?.sizes,
    },
  ];

  const handleAddFilter = (type, filter) => {
    setSelectedFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };

      if (!Array.isArray(updatedFilters[type])) {
        updatedFilters[type] = [];
      }

      if (type === "brands") {
        if (updatedFilters[type].includes(filter.id)) {
          updatedFilters[type] = updatedFilters[type].filter(
            (id) => id !== filter.id
          );
        } else {
          updatedFilters[type] = [...updatedFilters[type], filter.id];
        }
      } else {
        if (updatedFilters[type].includes(filter.title)) {
          updatedFilters[type] = updatedFilters[type].filter(
            (title) => title !== filter.title
          );
        } else {
          updatedFilters[type] = [...updatedFilters[type], filter.title];
        }
      }

      return updatedFilters;
    });
  };
  const icons3 = [
    ["", "", "", ""],
    ["", "", ""],
    ["", ""],
  ];
  const [openInde, setOpenInde] = useState(2);

  const handleRs = (index) => {
    setOpenInde(index);
  };

  const imagess = categoryD?.subcategories || [];
  const [startIndex, setStartIndex] = useState(0);

  const isRTL = document.dir === "rtl";
  const [animationDirection, setAnimationDirection] = useState("next");

  const getVisibleCount = () => {
    if (window.innerWidth >= 1400) return 4; // شاشات XL
    if (window.innerWidth >= 1200) return 4; // شاشات LG
    if (window.innerWidth >= 992) return 3; // شاشات MD
    if (window.innerWidth >= 768) return 3; // شاشات SM
    return 3; // شاشات XS - الشاشات الصغيرة جداً
  };

  const handleNext = () => {
    const visibleCount = getVisibleCount();
    if (startIndex + visibleCount < imagess.length) {
      setAnimationDirection("next"); // تحديد الاتجاه
      setStartIndex(startIndex + visibleCount);
    }
  };
  
  const handlePrev = () => {
    const visibleCount = getVisibleCount();
    if (startIndex - visibleCount >= 0) {
      setAnimationDirection("prev"); // تحديد الاتجاه
      setStartIndex(startIndex - visibleCount);
    }
  };

  const getVisibleImages = () => {
    const visibleCount = getVisibleCount();
    return imagess.slice(startIndex, startIndex + visibleCount).map((brand, index) => ({
      ...brand,
      animation: startIndex > 0 ? "slideIn 0.5s ease-in-out" : "slideOut 2s ease-in-out",
    }));
  };

  const show_searsh = useSelector((state) => state?.products?.searsh);

  const [isFilterVisible, setIsFilterVisible] = useState(true); 

  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  return (
    <div className="Brand">
      <Header />
      {showR && (
        <div className="overlay">
          <div
              className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
              style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
              }}
          >
              <Register />
          </div>
          </div>
        )}

      {show_searsh && (
        <Searsh />
      )}

      <div className={`containerGalleryMain container g-0 mt-5`}>
        <p className=" text-center font-size2 mt-5">{categoryD?.name}</p>
        {categoryD?.subcategories?.length !== 0 && categoryD?.subcategories && (
          <div className="galleryMain row justify-content-around align-items-center g-0">
            <div className="col-1 text-center icon">
              <img src={icon9} className="iconLeft" onClick={handlePrev} />
            </div>
            {getVisibleImages().map((category, index) => (
              <div
                className="col-3 text-center align-items-center g-0"
                key={`${category.id}-${index}`}
                style={{
                  animation: `${
                    animationDirection === "next"
                      ? isRTL
                        ? "slideInFromLeft"
                        : "slideInFromRight" 
                      : isRTL
                      ? "slideInFromRight"
                      : "slideInFromLeft"
                  } 0.5s ease-in-out`,
                }}
              >
                <div className="border3">
                  <img
                    src={category.image}
                    alt={`img-${index}`}
                    onClick={() => gotoCategory(category)}
                  />
                </div>
                <p>{category.name}</p>
              </div>
            ))}

            <div className="col-1 text-center icon">
              <img src={icon9} className="iconRitgh" onClick={handleNext} />
            </div>
          </div>
        )}
      </div>
      <span className="hr"></span>
      <div className="containe container">
        <div className="border_box2">
          <div className="background">
            <p className="Produ">
              {filters_data?.data?.data?.total_products} {t("Products")}
            </p>
            <div>
              {icons3.map((e, i) => (
                <div
                  key={i}
                  className={
                    e.length === 2
                      ? "show-on-small1"
                      : e.length === 3
                      ? "show-on-small2"
                      : e.length === 4
                      ? "show-on-small3"
                      : ""
                  }
                >
                  <p
                    className={`p ${openInde === i ? "selected" : ""}`}
                    onClick={() => handleRs(i)}
                  >
                    {e.map((item, index) => (
                      <span
                        key={index}
                        className={openInde === i ? "selected" : ""}
                      >
                        {item}
                      </span>
                    ))}
                  </p>
                  {openInde === i && (
                    <span
                      className="arrow"
                      style={{
                        marginInlineStart:
                          document.documentElement.dir === "rtl"
                            ? "-7px"
                            : openInde === 0 || openInde === 1 || openInde === 2
                            ? "-25px"
                            : "",
                      }}
                    >
                      &#9650;
                    </span>
                  )}
                </div>
              ))}
            </div>

            <div className="boxList">
              <div className="level">
                <p>
                  {t("Sort by")}: <span>{text}</span>
                </p>
                <i
                  onClick={handelClick}
                  className={`${icon ? "activ" : "noActiv"}`}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </i>
              </div>

              {icon && (
                <div className="levels">
                  {sorts_data?.data?.data?.filter_titles.map((e, i) => (
                    <p key={i} onClick={() => (valueTeaxt(e), setIcon(!icon))}>
                      {e}
                    </p>
                  ))}
                </div>
              )}
            </div>
            <button className="close-btns" onClick={() => window.location.reload()}>{t('clearSortAndFilter')}</button>
          </div>
        </div>
      </div>

      <div className="main-container container d-flex align-items-start">
        <div
          className={`main-cont ${
            isFilterVisible ? "col-0" : "col-12"
          } col-sm-4 ${isFilterVisible ? "slide-in" : "slide-out"}`}
          style={{
            display: openInde === 0 || openInde === 1 ? "none" : "block",
          }}
        >
          <button
            className="toggle-filter-btn"
            onClick={toggleFilterVisibility}
          >
            {isFilterVisible ? (
              <FontAwesomeIcon icon={faChevronRight} />
            ) : (
              <FontAwesomeIcon icon={faTimes} />
            )}
          </button>

          <div className="Filter_icon m-1">
            <p>{t("Filter")}</p>
            <i className="i" onClick={handleFilterDataClick}>
              <FontAwesomeIcon icon={faCheck} />
            </i>
          </div>
          {items?.map((item, index) => (
            <div key={index} className="main-item">
              <div
                className="item-headerr"
                onClick={() =>
                  setOpenIndex(openIndex === index + 1 ? null : index + 1)
                }
              >
                <p>{item.title}</p>
                <p className="arrow">
                  <i>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </i>
                </p>
              </div>
              {openIndex === index + 1 && (
                <div className="sub-items">
                  {item?.subItems?.map((subItem, subIndex) => (
                    <div
                      key={subIndex}
                      className="sub-item d-flex justify-content-between hover-bg"
                      onClick={() =>
                        handleAddFilter(item.key, {
                          title: subItem.filter_title,
                        })
                      }
                    >
                      <p>{subItem.filter_title}</p>
                      <div className="m d-flex ">
                        <p className="mx-2">{subItem.quantity}</p>
                        {selectedFilters[item.key]?.includes(
                          subItem.filter_title
                        ) && <span>✅</span>}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div
          className={`gallery1 container col-11 col-sm-${
            openInde === 0 ? 12 : openInde === 1 ? 12 : 7
          } `}
        >
          <div className="row">
            {loadingSearsh_brand && <Loader />}
            {loadingSort_productS && <Loader />}
            {loadingFilter_brduct && <Loader />}
            {loadingShow_brand && <Loader />}

            {allProducts.map((product, index) => {
              // تحقق ما إذا كان المنتج موجود في قائمة الأمنيات
              const isInWishlist = favorite?.some(
                (item) => item.product_id === product.id
              );

              return (
                <>
                  {isFilterVisible && (
                    <div
                      className={`box mb-3 mx-auto  col-xxl-${
                        openInde === 0
                          ? 3
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 5
                          : 12
                      } px-xxl-${
                        openInde === 0
                          ? 5
                          : openInde === 1
                          ? 5
                          : openInde === 2
                          ? 5
                          : 0
                      } mx-xxl-${
                        openInde === 0
                          ? 0
                          : openInde === 1
                          ? 5
                          : openInde === 2
                          ? 3
                          : 0
                      }
        col-xl-${
          openInde === 0 ? 3 : openInde === 1 ? 3 : openInde === 2 ? 5 : 12
        } px-xl-${
                        openInde === 0
                          ? 4
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 3
                          : 0
                      } mx-xl-${
                        openInde === 0
                          ? 0
                          : openInde === 1
                          ? 2
                          : openInde === 2
                          ? 3
                          : 0
                      }
        col-lg-${
          openInde === 0 ? 3 : openInde === 1 ? 4 : openInde === 2 ? 5 : 12
        } px-lg-${
                        openInde === 0
                          ? 2
                          : openInde === 1
                          ? 5
                          : openInde === 2
                          ? 1
                          : 0
                      }
        col-md-${
          openInde === 0 ? 4 : openInde === 1 ? 4 : openInde === 2 ? 6 : 12
        } px-md-${
                        openInde === 0
                          ? 1
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 1
                          : 0
                      }
        col-sm-${
          openInde === 0 ? 4 : openInde === 1 ? 5 : openInde === 2 ? 11 : 12
        } px-sm-${
                        openInde === 0
                          ? 1
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 4
                          : 0
                      }
        col-${
          openInde === 0 ? 5 : openInde === 1 ? 5 : openInde === 2 ? 5 : 12
        } px-xs-${
                        openInde === 0
                          ? 1
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 0
                          : 0
                      }
        text-center g-0`}
                    >
                      <div className="border_box mb-5 ">
                        <div className="padding_box" onClick={() => gotoProductDetails(product)}>
                          <i
                            onClick={(event) => {
                              handelAdd_wishlist(product.id, event);
                              event.stopPropagation();
      
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faHeart}
                              style={{ color: isInWishlist ? "red" : "white" }}
                            />
                          </i>
                          {product?.discount && (
                            <p className="discount">Off {product?.discount}</p>
                          )}
                          {product.main_image && (
                            <img
                              src={product.main_image}
                              alt={`img-${index}`}
                            />
                          )}
                          <p className="discraptoin">{product?.description}</p>
                          <div className="price align-items-center">
                            <p>{product?.new_price}</p>
                            {product?.old_price && (
                              <p className="old_price">{product?.old_price}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        </div>
      </div>
      <Footer Sign_Up={Sign_Up} />
    </div>
  );
}

export default SubSupCategory;
